import { IconProps } from '.';

export const CompassIcon = ({ className = '', color = 'black' }: IconProps) => {
  return (
    <svg
      className={className}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM11.8196 5.23171C12.406 5.03627 12.9638 5.59407 12.7683 6.18039L11.2399 10.7656C11.1653 10.9895 10.9895 11.1653 10.7656 11.2399L6.1804 12.7683C5.59408 12.9637 5.03628 12.4059 5.23172 11.8196L6.76011 7.23444C6.83476 7.01049 7.0105 6.83475 7.23445 6.7601L11.8196 5.23171ZM7.12908 10.8709L8.06455 8.06454L10.8709 7.12908L9.93548 9.93547L7.12908 10.8709Z'
        fill={color}
      />
    </svg>
  );
};
